"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNPLANNED_FORM_REMINDER_DAYS = exports.PLANNED_NOTICE_DAYS = exports.EPA_CONTACT_WINDOW_DAYS = void 0;
exports.epaContactDeadline = epaContactDeadline;
exports.plannedFilingDeadline = plannedFilingDeadline;
exports.unplannedFormReminderDate = unplannedFormReminderDate;
exports.deadlinePassed = deadlinePassed;
exports.contactTimeliness = contactTimeliness;
exports.plannedFilingTimeliness = plannedFilingTimeliness;
exports.formFiled = formFiled;
exports.contactObligationMet = contactObligationMet;
const date_1 = require("encamp-shared/dist/utils/date");
const clockStatus_1 = require("../clockStatus");
/**
 * Calendar days after an unplanned event starts within which EPA must be
 * contacted (40 CFR 262.233). Judged per calendar day: a contact on day 3 is
 * timely, day 4 is late.
 */
exports.EPA_CONTACT_WINDOW_DAYS = 3;
/** Calendar days before a planned event starts by which Form 8700-12 is due. */
exports.PLANNED_NOTICE_DAYS = 30;
/**
 * Encamp policy, not regulation: the rule sets no deadline for an unplanned
 * event's follow-up Form 8700-12, so this is when a missing one earns a reminder.
 */
exports.UNPLANNED_FORM_REMINDER_DAYS = 30;
function epaContactDeadline(startDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(startDate), exports.EPA_CONTACT_WINDOW_DAYS);
}
function plannedFilingDeadline(startDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(startDate), -exports.PLANNED_NOTICE_DAYS);
}
function unplannedFormReminderDate(startDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(startDate), exports.UNPLANNED_FORM_REMINDER_DAYS);
}
/** True once today's UTC calendar date is strictly after the deadline's. */
function deadlinePassed(deadline, now) {
    return (0, clockStatus_1.daysRemaining)(deadline, now) < 0;
}
function contactTimeliness(startDate, contactDate) {
    const start = (0, date_1.floorToUtcMidnight)(startDate).getTime();
    const contact = (0, date_1.floorToUtcMidnight)(contactDate).getTime();
    if (contact < start) {
        return "beforeEvent";
    }
    return contact <= epaContactDeadline(startDate).getTime() ? "timely" : "late";
}
function plannedFilingTimeliness(startDate, filedDate) {
    const filed = (0, date_1.floorToUtcMidnight)(filedDate).getTime();
    return filed <= plannedFilingDeadline(startDate).getTime() ? "timely" : "late";
}
function formFiled(evidence) {
    return evidence.filings.length > 0;
}
/**
 * A form completed inside the 72-hour window satisfies the contact obligation
 * too (SME crossover rule). A form with no date cannot prove when it was filed.
 */
function contactObligationMet(evidence) {
    if (evidence.contactRecorded) {
        return true;
    }
    return evidence.filings.some((filing) => filing.filedOn !== null && contactTimeliness(evidence.startDate, filing.filedOn) === "timely");
}
//# sourceMappingURL=notices.js.map